import React from "react";
import * as CallDepartmentsAction from "../../store/actions/CallDepartments";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Permission from "../../components/Common/Permission";
import FilterButton from "../../components/Common/FilterButton";
import Button from "sushiweb/Button";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import CallDepartmentList from "../../components/LogisticsSupport/CallDepartments";
import ListPagination from "../../components/Common/ListPagination";
import { useHistory, useParams } from "react-router-dom";
import { getPath } from "../../utils";
import CallDepartmentModal from "../../components/LogisticsSupport/CallDepartments/CallDepartmentModal";

const CallDepartments = (props) => {
  const {
    getCallDepartmentList,
    callDepartmentsList,
    nextPage,
    prevPage,
    activeFilters,
    setCallDepartmentsActiveObject,
    currentPageReducer,
  } = props;
  const [currentPage, setCurrentPage] = React.useState(1);
  const [modalState, setModalState] = React.useState(false);
  const [activeId, setActiveId] = React.useState("");
  const params = useParams();
  const history = useHistory();
  const shouldRenderList = getPath(params, "id", undefined) === undefined;

  const allActions =
    MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS];

  React.useEffect(() => {
    if (shouldRenderList === true) {
      getCallDepartmentList(currentPageReducer, activeFilters);
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  // type => modalType
  // id for which obj we have to handle
  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  // to handle filters change
  React.useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(activeFilters)]);
  const handleNavClick = (action) => {
    if (action === "prev") {
      getCallDepartmentList(currentPage - 1, activeFilters);
      setCurrentPage(currentPage - 1);
    } else {
      getCallDepartmentList(currentPage + 1, activeFilters);
      setCurrentPage(currentPage + 1);
    }
  };

  const handleClose = () => {
    setModalState(false);
    setCallDepartmentsActiveObject({});
    if (
      history.location.pathname !== "/call-departments" &&
      getPath(callDepartmentsList, "length", -1) > 0
    ) {
      //no page refresh, hence redux store will persist
      window.history.pushState("", "", "/call-departments");
    } else if (
      history.location.pathname !== "/call-departments" &&
      getPath(callDepartmentsList, "length", -1) === 0
    ) {
      // clear everything and page refresh
      history.push("/call-departments");
    }
  };

  return (
    <CallDepartmentViewContainer>
      <FlexContainer align="flex-start">
        <Heading>Call Departments</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.READ]}>
            <FilterButton
              activeFilters={activeFilters}
              data-testid="callDepartmentsFilterButton"
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.UPDATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="callDepartmentsCreationButton"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <CallDepartmentList
        callDepartmentsList={callDepartmentsList}
        activeId={activeId}
        handleClick={handleClick}
      />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && (
        <CallDepartmentModal
          activeId={activeId}
          modalState={modalState}
          handleClose={handleClose}
        />
      )}
    </CallDepartmentViewContainer>
  );
};

const CallDepartmentViewContainer = styled.section``;

function mapStateToProps(state) {
  const { CallDepartments } = state;
  return {
    callDepartmentsList: CallDepartments.callDepartmentsList,
    prevPage: CallDepartments.prevPage,
    nextPage: CallDepartments.nextPage,
    activeFilters: CallDepartments.activeFilters,
    currentPageReducer: CallDepartments.currentPage,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getCallDepartmentList: bindActionCreators(
      CallDepartmentsAction.getCallDepartmentList,
      dispatch
    ),
    setCallDepartmentsActiveObject: bindActionCreators(
      CallDepartmentsAction.setCallDepartmentsActiveObject,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CallDepartments);
